import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { MediaModalComponent } from "../../ui/modal/media-modal/media-modal.component";
import { ToastrService } from 'ngx-toastr';
import { FileTypeValue } from '@/app/shared/interfaces/file.interface';
// import { Attachment } from '../../../interface/attachment.interface';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent {

  @ViewChild("mediaModal") MediaModal: MediaModalComponent | undefined;

  @Input() imagesList: any[] = [];
  @Input() images: any[] = [];
  @Input() image: any | null;
  @Input() id: string | undefined;
  @Input() imageUrl: string | null | undefined;
  @Input() url: boolean = false;
  @Input() multipleImage: boolean = false;
  @Input() helpText: string | undefined;
  @Input() selectedImages: any[] = [];
  @Input() fileType: string = FileTypeValue.ProductImage;

  @Output() selectedFiles: EventEmitter<any> = new EventEmitter();
  public showImages: any[] = [];
  public showImage: any | null;
  public showImageUrl: String | null | undefined;

  constructor(
    private toastService: ToastrService,
  ) { }

  ngOnChanges() {
    this.showImage = this.image;
    this.showImages = this.images;
    this.showImageUrl = this.imageUrl;
  }

  selectImage(data: any, url: boolean) {
    if(Array.isArray(data)) {
      this.images = data;
      this.showImages = data;
    } else if(url) {
      this.imageUrl = data.original_url;
      this.showImageUrl = data.original_url;
    } else {
      this.image = data;
      if (data && typeof(data) == "object") {
        this.showImage = data.fileUrl;
      }
      else {
        this.showImage = data;
      }
    }
    if(this.imageUrl) {
      this.selectedFiles.emit(this.imageUrl);
    } else {
      this.selectedFiles.emit(this.images?.length ? this.images : this.image);
    }
  }

  remove(index: number, type: string) {
    if(type == 'multiple' && Array.isArray(this.images)) {
      if (this.images.length <= 1) {
        this.toastService.error("Can not delete, product must has at least 1 image!");
        return;
      }
      this.images.splice(index, 1);
      this.showImages = this.images;
    } else if(type == 'single_image_url') {
      this.imageUrl = null;
      this.showImageUrl = null;
      this.image = null;
    } else {
      this.image = null;
      this.showImage = null;
    }
    this.selectedFiles.emit(this.images.length ? this.images : this.image);
  }

  newImagesList(data: any) {
    setTimeout(() => {
      this.imagesList.push(data);
    }, 1000); // because seem api return data but file doesn't available on tebi
  }

}
